import { RoutePathsEnum } from "infrastructure/RoutePathsEnum";
import IEditAuthorisedMaintenanceRequestModel from "interfaces/Request/IEditAuthorisedMaintenanceRequestModel";
import ISiteDiaryAuthorisedMaintenanceViewModel from "interfaces/SiteDiary/AuthorisedMaintenance/ISiteDiaryAuthorisedMaintenanceViewModel";
import { PencilSquare } from "react-bootstrap-icons";
import { Link } from "react-router-dom";

const EditTemplate = (props: ISiteDiaryAuthorisedMaintenanceViewModel): any => {
  const {
    id, undertakenBy, atwPtwNumber, details, hwrcSiteId, diaryDate
  } = props;

  const editUrl = encodeURI(`${RoutePathsEnum.AuthorisedMaintenanceEdit}/${hwrcSiteId}/${diaryDate}/${id}`);
  const editData : IEditAuthorisedMaintenanceRequestModel = {
    undertakenBy,
    atwPtwNumber,
    details
  };

  const handleContextMenu = (event:any) => {
    event.preventDefault();
  };
  return (
    <>
      <Link data-testid="editAuthorisedMaintenanceButton" state={editData} to={editUrl} onContextMenu={handleContextMenu}>
        <PencilSquare color="#000" />
        <span className="visually-hidden">
          edit
          {undertakenBy}
          {" "}
          {atwPtwNumber}
        </span>
      </Link>
    </>
  );
};

export default EditTemplate;
